module.exports = __webpack_public_path__ + "img/Remote-Bus.e2388576.svg";